// src/app/components/navbar/navbar.component.ts
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NavMenu } from 'src/app/interfaces/nav-menu';

@Component({
	selector: 'app-navbar',
	standalone: true,
	imports: [CommonModule, RouterLink, RouterLinkActive], // ngFor/ngClass + routerLink/Active
	templateUrl: './navbar.component.html',
	styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
	theme: 'light' | 'dark' = 'light';
	toggleMe = false;
	navMenus: NavMenu[] = [
		{ path: 'home', icon: 'fas fa-home fa-2x', btnText: 'Wordy' },
		{ path: 'about', icon: 'fas fa-info fa-2x', btnText: 'About' },
	];

	constructor() {
		// On load, set theme from localStorage or system
		const saved = localStorage.getItem('theme');
		if (saved) {
			document.documentElement.setAttribute('data-theme', saved);
			this.theme = saved === 'dark' ? 'dark' : 'light';
		} else if (
			window.matchMedia &&
			window.matchMedia('(prefers-color-scheme: dark)').matches
		) {
			document.documentElement.setAttribute('data-theme', 'dark');
			this.theme = 'dark';
		}

		// Listen for system theme changes when there is no saved preference
		if (!localStorage.getItem('theme') && window.matchMedia) {
			const mq = window.matchMedia('(prefers-color-scheme: dark)');
			mq.addEventListener?.('change', (e) => {
				if (!localStorage.getItem('theme')) {
					document.documentElement.setAttribute(
						'data-theme',
						e.matches ? 'dark' : 'light'
					);
					this.theme = e.matches ? 'dark' : 'light';
				}
			});
		}
	}

	ngOnInit(): void {}
	clickit(): void {
		this.toggleMe = !this.toggleMe;
	}

	toggleTheme() {
		const current = document.documentElement.getAttribute('data-theme');
		if (current === 'dark') {
			document.documentElement.setAttribute('data-theme', 'light');
			localStorage.setItem('theme', 'light');
			this.theme = 'light';
		} else {
			document.documentElement.setAttribute('data-theme', 'dark');
			localStorage.setItem('theme', 'dark');
			this.theme = 'dark';
		}
	}
}
